import { ValidationTypes } from "../form";

const ValidationConstants = {
  TYPES: {
    SUCCESS: "success" as ValidationTypes,
    ERROR: "error" as ValidationTypes,
  },
};
export default ValidationConstants;
